import { Column } from '../container/Container';
import { CustomText, TextHeadlineExtraExtraLarge } from '../text/Texts';

type Props = {
	companyName?: string;
	heading?: string;
};

const CompanyAndHeading = ({
	companyName = 'Para Xpress Technologies Services Inc.',
	heading = 'Heading',
}: Props) => {
	return (
		<Column gap="gap-2">
			<CustomText
				text={companyName}
				className="text-primaryContainer font-normal leading-[20px] text-[20px]"
			/>
			<TextHeadlineExtraExtraLarge text={heading} className="text-primary" />
		</Column>
	);
};

export default CompanyAndHeading;
